import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';

class ListHistoryRowItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }
  handleClickDetail() {
    this.props.handleViewDetail(this.props.item);
  }

  render() {
    return (
      <tr className="row-list-items-giaiquyetdon">
        <td>{(this.props.count) ? this.props.count : ''}</td>
        <td>{this.props.item.noiDung}</td>
        <td>{this.props.item.hoTenCongChucThayDoi}<br/>
          Đơn vị: {this.props.item.donViCongChucThayDoi}<br/>
          Vào lúc {moment(this.props.item.ngaySua).format('HH:mm:ss [ngày] DD/MM/YYYY')}
        </td>
        <td>
          <Link onClick={this.handleClickDetail.bind(this)}>Xem chi tiết</Link>
        </td>

      </tr>
    );
  }
}

export default ListHistoryRowItem;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/datatable/rowItem/ListHistoryRowItem.jsx